import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'clientGroups',
    collectionActionName: 'CLIENT_GROUPS',
    itemActionName: 'CLIENT_GROUP',
});
